export default __webpack_public_path__ + "static/media/carbon_delete.ea167fbb.svg";